import { IconLayer, IconLayerProps } from "@deck.gl/layers";
import { useSelector } from "react-redux";

import { XYLocation } from "@nens/deck-gl";

import { getXY } from "../../state/selectedPoint";

import { ICON_MAPPING } from "./DeckGlConsts";

const useSelectedPointLayer = () => {
  const selectedPointMarker = useSelector(getXY);

  const defaultIconLayerProps = {
    iconAtlas: "./assets/images/iconAtlas.png",
    iconMapping: ICON_MAPPING,
    sizeUnits: "pixels",
    getSize: 50,
    getPosition: (d: XYLocation) => {
      return d;
    },
    pickable: false,
  } as unknown as IconLayerProps;

  return [
    new IconLayer({
      ...defaultIconLayerProps,
      id: "selected-point-layer",
      data: selectedPointMarker ? [selectedPointMarker] : [],
      getIcon: () => "selectedPointPin",
    }),
  ];
};

export default useSelectedPointLayer;
